module.exports = __webpack_public_path__ + "static/media/Cuvette.f496241d.svg";